// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"c7c8438b","220":"366cc424","239":"2f768d6b","732":"e159fe3d","977":"51a1344e"}[chunkId] + ".chunk.js";
};